import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import bind from 'bind-decorator';
import { Button, Icon } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'underscore';
import Execution from '@/models/execution';
import ModelTable from '../Shared/ModelTable';

class ReportList extends Component {
  static propTypes = {
    reportTasks: PropTypes.array,
    reports: PropTypes.array,
  };

  @bind
  getModelTableUpdateHandler(modelTableUpdateMethod) {
    this.modelTableUpdateMethod = modelTableUpdateMethod;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reportTasks !== this.props.reportTasks && this.modelTableUpdateMethod) {
      this.modelTableUpdateMethod();
    }
  }

  renderStatusButton(status, downloadURL) {
    const statusConfig = {
      1: {
        color: 'blue',
        icon: 'download',
        text: 'Download',
      },
      2: {
        color: 'blue',
        icon: 'download',
        text: 'Download',
      },
      3: {
        color: 'yellow',
        icon: 'exclamation triangle',
        text: 'No Data',
      },
      4: {
        color: 'red',
        icon: 'exclamation triangle',
        text: 'Error',
      },
    };
    const config = statusConfig[status] || {
      color: null,
      icon: null,
      text: 'Running',
    };
    return (
      <Button
        href={downloadURL || undefined}
        disabled={!downloadURL}
        color={config.color}
        icon
        labelPosition="left"
      >
        {config.icon && <Icon name={config.icon} />}
        {config.text}
      </Button>
    );
  }

  render() {
    const reportTypeFilters = this.props.reports.reduce((acc, report) => {
      acc[report.name] = report.display_name;
      return acc;
    }, {});
    const statusFilters = {
      null: 'Running',
      1: 'Download',
      2: 'Download',
      3: 'No Data',
      4: 'Error',
    };
    const reportColumns = [
      {
        name: 'Time Run',
        sort: true,
        key: ['created_at', (createdAt) => moment(createdAt).format('MMMM Do YYYY, hh:mm a')],
      },
      {
        name: 'Report Type',
        filter: reportTypeFilters,
        key: ['type', (type) => (_.findWhere(this.props.reports, { name: type }) || {}).display_name || type],
      },
      {
        name: 'Status',
        filter: statusFilters,
        key: ['status', 'download_url', (status, downloadURL) => this.renderStatusButton(status, downloadURL)],
      },
      {
        name: 'Message',
        key: 'message',
      },
    ];
    return (
      <ModelTable
        title="My Reports"
        model={Execution}
        columns={reportColumns}
        defaultSort={['created_at', 'dsc']}
        updateHandler={this.getModelTableUpdateHandler}
      />
    );
  }
}

export default Radium(ReportList);
